import {stringify} from 'csv-stringify/browser/esm/sync';
import saveAs from 'file-saver';

export default function saveAsCsv(data: string[][], filename: string) {
  const blob = new Blob([stringify(data)], {type: 'text/csv'});
  saveAs(blob, filename);
}
